import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 2v11h3v9l7-12h-4l3-8z"
}), 'FlashOnOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FlashOnOutlined.js
// module id = 3725
// module chunks = 2